/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateOwnerDto } from '../models/CreateOwnerDto';
import type { LoginDto } from '../models/LoginDto';
import type { LoginResponseDto } from '../models/LoginResponseDto';
import type { RegisteredOwnerResponseDto } from '../models/RegisteredOwnerResponseDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class AuthService {
    /**
     * Register a new owner (Admin only)
     * @param requestBody
     * @returns RegisteredOwnerResponseDto Owner registered successfully.
     * @throws ApiError
     */
    public static authControllerRegister(
        requestBody: CreateOwnerDto,
    ): CancelablePromise<RegisteredOwnerResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/auth/register',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request (e.g., validation error).`,
                403: `Forbidden - requires Admin role.`,
                409: `Conflict (e.g., username already exists).`,
            },
        });
    }
    /**
     * Log in an owner
     * @param requestBody
     * @returns LoginResponseDto Login successful, returns JWT token.
     * @throws ApiError
     */
    public static authControllerLogin(
        requestBody: LoginDto,
    ): CancelablePromise<LoginResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/auth/login',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized (invalid credentials).`,
            },
        });
    }
}
